﻿import React from 'react';
import PropTypes from 'prop-types';

export default class SelectMenu extends React.Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(val) {
        this.props.onChange(val.target.value);
    }

    renderOptions() {
        let options = [];
        this.props.options.map((option, index) => {
            options.push(<option key={"options" + index} value={option.value}>{option.text}</option>);
        });
        return options;
    }

    render() {
        let successState = null;
        if (this.props.isValid !== null && this.props.isValid !== undefined) {
            if (this.props.isValid) {
                successState = "is-valid";
            }
            else {
                successState = "is-invalid";
            }
        }
        let className = "wbm-select-menu ";
        if (!this.props.staticLabel) {
            className += "animated-placeholder ";
        }
        if (this.props.className) {
            className += this.props.className;
        }
        return (
            <div className={className}>
                {this.props.staticLabel && this.props.label &&
                    <div className="row">
                        <label htmlFor={this.props.id} className="col">{this.props.label} </label>                        
                    </div>
                }
                <select
                    id={this.props.id}
                    className={`custom-select${successState ? " form-control " + successState : " "}`}
                    value={this.props.value}
                    onChange={this.onChange}
                    disabled={this.props.disabled}
                    autoComplete="none"
                    required
                >
                    {
                        this.renderOptions()
                    }
                </select>
                {!this.props.staticLabel && this.props.label &&
                    <label htmlFor={this.props.id}>
                        {this.props.label}
                    </label>
                }
                <div className="invalid-feedback text">
                     <span className='invalid-icon'/>
                    {this.props.invalidFeedback}
                </div>
            </div>
        );
    }
}

SelectMenu.propTypes = {
    disabled: PropTypes.bool,
    invalidFeedback: PropTypes.string,
    isValid: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array,
    staticLabel: PropTypes.bool,
    value: PropTypes.node.isRequired
};